module.exports = __webpack_public_path__ + "img/arrow_right.1dcc0455.png";